import { Box, ResetCSS, ScrollToTopButtonV2, ToastListener } from '@pancakeswap/uikit'
import BigNumber from 'bignumber.js'
import { NetworkModal } from 'components/NetworkModal'
import { FixedSubgraphHealthIndicator } from 'components/SubgraphHealthIndicator/FixedSubgraphHealthIndicator'
import TransactionsDetailModal from 'components/TransactionDetailModal'
import { useAccountEventListener } from 'hooks/useAccountEventListener'
import useEagerConnect from 'hooks/useEagerConnect'
import useEagerConnectMP from 'hooks/useEagerConnect.bmp'
import useSentryUser from 'hooks/useSentryUser'
import useThemeCookie from 'hooks/useThemeCookie'
import useUserAgent from 'hooks/useUserAgent'
import { NextPage } from 'next'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import { Fragment, useEffect } from 'react'
import { DefaultSeo } from 'next-seo'
import { PageMeta } from 'components/Layout/Page'
import { SentryErrorBoundary } from 'components/ErrorBoundary'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, useStore } from 'state'
import { usePollBlockNumber } from 'state/block/hooks'
import { useTheme } from '@pancakeswap/hooks'
// import ReactGA from "react-ga"
// import { GoogleAnalytics } from "nextjs-google-analytics";
import ReactGA from "react-ga4";
import { GoogleTagManager, GoogleAnalytics } from '@next/third-parties/google'
import styled from 'styled-components'

import { Blocklist, Updaters } from '..'
import { SEO } from '../../next-seo.config'
import NavBar, { MenuBar, StatusBar } from '../components/EMenu'
import Providers from '../Providers'
import GlobalStyle from '../style/Global'



// This config is required for number formatting
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

function GlobalHooks() {
  usePollBlockNumber()
  useEagerConnect()
  useUserAgent()
  useAccountEventListener()
  useSentryUser()
  useThemeCookie()
  return null
}

function MPGlobalHooks() {
  usePollBlockNumber()
  useEagerConnectMP()
  useUserAgent()
  useAccountEventListener()
  useSentryUser()
  return null
}

// const trackingId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || ""
// ReactGA.initialize(trackingId)

function MyApp(props: AppProps<{ initialReduxState: any }>) {
  const { pageProps, Component } = props
  const store = useStore(pageProps.initialReduxState)

  // useEffect(() => {
  //   // initialize react GA on root app, or _app.js if using next js,
  //   const trackingId = "G-F3M5GTP0PM"
  //   ReactGA.initialize(trackingId)
  // }, [])

  return (
    <>
      {/* <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || ""} /> */}
      <GoogleTagManager gtmId="GTM-P532WJKB" />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=5, minimum-scale=1, viewport-fit=cover"
        />
        <meta name="theme-color" content="#1FC7D4" />
        {(Component as NextPageWithLayout).mp && (
          // @ts-ignore
          <script src="https://public.bnbstatic.com/static/js/mp-webview-sdk/webview-v1.0.0.min.js" id="mp-webview" />
        )}
        {/* <link href="https://fonts.googleapis.com/css2?family=Kanit:wght@400;600&display=swap" /> */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pdex.vision" />
        <meta property="og:title" content="pDEX.vision" />
        <meta property="og:description" content="Liquidity and trading infrastructure for the PulseChain Renaissance" />
        <meta property="og:image" content="https://pdex.vision/images/share-logo.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="pDEX.vision" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="pDEX.vision" />
        <meta name="twitter:description" content="Liquidity and trading infrastructure for the PulseChain Renaissance" />
        <meta name="twitter:image" content="https://pdex.vision/images/share-logo.png" />
        <meta name="twitter:domain" content="pdex.vision" />
        <meta name="twitter:url" content="https://pdex.vision" />

        <link rel="canonical" href="https://pdex.vision" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
      </Head>


      <DefaultSeo {...SEO} />
      <Providers store={store}>
        <PageMeta />
        {(Component as NextPageWithLayout).Meta && (
          // @ts-ignore
          <Component.Meta {...pageProps} />
        )}
        <Blocklist>
          {(Component as NextPageWithLayout).mp ? <MPGlobalHooks /> : <GlobalHooks />}
          <ResetCSS />
          <GlobalStyle />
          <PersistGate loading={null} persistor={persistor}>
            <Updaters />
            <App {...props} />
          </PersistGate>
        </Blocklist>
      </Providers>
      <GoogleAnalytics gaId="G-F3M5GTP0PM" />
    </>
  )
}

type NextPageWithLayout = NextPage & {
  Layout?: React.FC<React.PropsWithChildren<unknown>>
  /** render component without all layouts */
  pure?: true
  /** is mini program */
  mp?: boolean
  /**
   * allow chain per page, empty array bypass chain block modal
   * @default [ChainId.PULSE]
   * */
  chains?: number[]
  isShowScrollToTopButton?: true
  /**
   * Meta component for page, hacky solution for static build page to avoid `PersistGate` which blocks the page from rendering
   */
  Meta?: React.FC<React.PropsWithChildren<unknown>>
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

const Background = styled.img`
  position: fixed;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  user-select: none;
  z-index: -1;
  @media (max-width: 480px) {
    width: auto;
  }
`

const ProductionErrorBoundary = process.env.NODE_ENV === 'production' ? SentryErrorBoundary : Fragment

const App = ({ Component, pageProps }: AppPropsWithLayout) => {
  const { setTheme } = useTheme()

  useEffect(() => {
    setTheme('dark')
  })

  if (Component.pure) {
    return <Component {...pageProps} />
  }

  // Use the layout defined at the page level, if available
  const Layout = Component.Layout || Fragment
  // const ShowMenu = Component.mp ? Fragment : Menu
  const isShowScrollToTopButton = Component.isShowScrollToTopButton || true

  return (
    <ProductionErrorBoundary>
      <Background src="/assets/bg1.png" />
      <Layout>
        <MenuBar />
        <Box pt={["90px", "90px", "100px"]} pb={["72px", "72px", "32px"]} px={["8px", "16px", 0]}>
          <Component {...pageProps} />
        </Box>
        <NavBar />
        <StatusBar />
      </Layout>
      {isShowScrollToTopButton && <ScrollToTopButtonV2 />}
      <ToastListener />
      <FixedSubgraphHealthIndicator />
      <NetworkModal pageSupportedChains={Component.chains} />
      <TransactionsDetailModal />
    </ProductionErrorBoundary>
  )
}

export default MyApp
